import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/EditJob.css';

const EditJob = () => {
    const { id } = useParams(); // Get job ID from URL
    const navigate = useNavigate();
    
    // Job state variables
    const [jobData, setJobData] = useState({
        title: '',
        description: '',
        interviewDeadline: '',
        visaStatus: '',
        jobType: '',
        minimumRequirements: '',
        preferredRequirements: ''
    });

    const [message, setMessage] = useState('');

    // Fetch job details on component load
    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                const response = await axios.get(`http://127.0.0.1:5000/jobs/${id}`);
                console.log("Job Details Fetched:", response.data);
                setJobData(response.data); // Pre-fill form with job details
            } catch (err) {
                console.error('Error fetching job details:', err);
                alert('Failed to load job details.');
            }
        };

        fetchJobDetails();
    }, [id]);

    // Handle input changes
    const handleChange = (e) => {
        setJobData({ ...jobData, [e.target.name]: e.target.value });
    };

    // Handle job update
    const handleUpdateJob = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(
                `http://127.0.0.1:5000/jobs/${id}`,
                jobData
            );
            setMessage(response.data.message);
            setTimeout(() => navigate('/dashboard'), 2000); // Redirect to dashboard after update
        } catch (err) {
            console.error('Error updating job:', err);
            setMessage('Failed to update job.');
        }
    };

    return (
        <div className="edit-job-container">
            <h2>Edit Job Details</h2>
            <form onSubmit={handleUpdateJob}>
                <label>Job Title:</label>
                <input
                    type="text"
                    name="title"
                    value={jobData.title}
                    onChange={handleChange}
                    required
                />

                <label>Job Summary:</label>
                <textarea
                    name="description"
                    value={jobData.description}
                    onChange={handleChange}
                    required
                ></textarea>

                <label>Time to Expiration:</label>
                <input
                    type="date"
                    name="interviewDeadline"
                    value={jobData.interviewDeadline}
                    onChange={handleChange}
                    required
                />

                <label>Work/VISA Status:</label>
                <select
                    name="visaStatus"
                    value={jobData.visaStatus}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select Work/VISA Status</option>
                    <option value="Citizen">Citizen</option>
                    <option value="Green Card Holder">Green Card Holder</option>
                    <option value="H-1B Visa">H-1B Visa</option>
                    <option value="L-1 Visa">L-1 Visa</option>
                    <option value="OPT">OPT</option>
                    <option value="CPT">CPT</option>
                    <option value="TN Visa">TN Visa</option>
                    <option value="Other">Other</option>
                </select>

                <label>Job Type:</label>
                <select
                    name="jobType"
                    value={jobData.jobType}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select</option>
                    <option value="FTE">Full-Time</option>
                    <option value="Part-Time">Part-Time</option>
                    <option value="Contract">Contract</option>
                </select>

                <label>Minimum Requirements:</label>
                <textarea
                    name="minimumRequirements"
                    value={jobData.minimumRequirements}
                    onChange={handleChange}
                ></textarea>

                <label>Preferred Requirements:</label>
                <textarea
                    name="preferredRequirements"
                    value={jobData.preferredRequirements}
                    onChange={handleChange}
                ></textarea>

                <button type="submit" className="update-btn">Update Job</button>
                <button type="button" className="cancel-btn" onClick={() => navigate('/dashboard')}>
                    Cancel
                </button>
            </form>

            {message && <p className="message">{message}</p>}
        </div>
    );
};

export default EditJob;

